import PropTypes from 'prop-types'
import { compose } from 'redux'
import { InfoButton } from 'components/buttons'
import { withActiveProductFilters } from 'store/reducers'
import { InlineFilters } from './inline-filters'
import {
  FILTERS,
  SECTIONS,
  sectionOptions,
  hideProductType,
  areFiltersApplied,
  getFilteredProductsCount,
} from '../helpers'

const FilterOptionsBase = ({ openPanel, productFilters, products }) => (
  <div className="mbl">
    <InfoButton
      pill
      size="small"
      empty
      className="mrm"
      onClick={() => openPanel(SECTIONS.SORT)}
    >
      {SECTIONS.SORT}
    </InfoButton>
    <InfoButton
      pill
      size="small"
      className="mrm"
      empty={
        !productFilters[FILTERS.BRANDS] ||
        productFilters[FILTERS.BRANDS].length === 0
      }
      onClick={() => openPanel(SECTIONS.BRANDS)}
    >
      {SECTIONS.BRANDS}
    </InfoButton>
    {!hideProductType() && (
      <InfoButton
        pill
        size="small"
        className="mrm"
        empty={
          !productFilters[FILTERS.CATEGORIES] ||
          productFilters[FILTERS.CATEGORIES].length === 0
        }
        onClick={() => openPanel(SECTIONS.PRODUCT_TYPE)}
      >
        {SECTIONS.PRODUCT_TYPE}
      </InfoButton>
    )}
    <InfoButton
      pill
      size="small"
      className="mrm"
      onClick={() => openPanel(SECTIONS.RATING)}
      empty={!productFilters[FILTERS.MIN_RATING]}
    >
      {SECTIONS.RATING}
    </InfoButton>
    <InfoButton
      pill
      size="small"
      className="mrm"
      onClick={() => openPanel(SECTIONS.PRICE_RANGE)}
      empty={
        !productFilters[FILTERS.MIN_PRICE] && !productFilters[FILTERS.MIN_PRICE]
      }
    >
      {SECTIONS.PRICE_RANGE}
    </InfoButton>
    <InlineFilters
      inStockDisabled={
        getFilteredProductsCount(products, { [FILTERS.AVAILABLE]: true }) === 0
      }
      onSaleDisabled={
        getFilteredProductsCount(products, { [FILTERS.ON_SALE]: true }) === 0
      }
    />
  </div>
)

FilterOptionsBase.propTypes = {
  products: PropTypes.array.isRequired,
  productFilters: PropTypes.object.isRequired,
  openPanel: PropTypes.func.isRequired,
}

const CollapsedFilterOptionsBase = ({
  openPanel,
  products,
  productFilters,
}) => (
  <div className="mvl">
    <InfoButton
      pill
      empty
      size="small"
      className="mrm"
      onClick={() => openPanel(SECTIONS.SORT)}
    >
      {SECTIONS.SORT}
    </InfoButton>
    <InfoButton
      pill
      size="small"
      className="mrm"
      onClick={() => openPanel()}
      empty={!areFiltersApplied(productFilters)}
    >
      Filter
    </InfoButton>
    <InlineFilters
      inStockDisabled={
        getFilteredProductsCount(products, { [FILTERS.AVAILABLE]: true }) === 0
      }
      onSaleDisabled={
        getFilteredProductsCount(products, { [FILTERS.ON_SALE]: true }) === 0
      }
    />
  </div>
)

CollapsedFilterOptionsBase.propTypes = FilterOptionsBase.propTypes

export const FilterOptions = compose(withActiveProductFilters())(
  FilterOptionsBase
)
export const CollapsedFilterOptions = compose(withActiveProductFilters())(
  CollapsedFilterOptionsBase
)
